// extracted by mini-css-extract-plugin
export default {"root":"UserRatingStrip_root__A8pyF","rank":"UserRatingStrip_rank__+nXft","details":"UserRatingStrip_details__no065"};